module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/funding/funding-details/funding-details.component.css
// module id = ./src/app/components/funding/funding-details/funding-details.component.css
// module chunks = main